import React, { createContext, useContext, useMemo } from 'react';
import PropTypes from 'prop-types';

const AllocationChartContext = createContext();

export const useAllocationChartContext = () =>
  useContext(AllocationChartContext);

export const AllocationChartContextProvider = ({
  children,
  allocationChartRef
}) => {
  const contextValue = useMemo(
    () => ({
      allocationChartRef
    }),
    [allocationChartRef]
  );

  return (
    <AllocationChartContext.Provider value={contextValue}>
      {children}
    </AllocationChartContext.Provider>
  );
};

AllocationChartContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
  allocationChartRef: PropTypes.object.isRequired
};

export default AllocationChartContext;
